
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../shared/colors";

const useStyles = makeStyles( theme => ({
    warningIcon: {
        color: colors.magellanMediumOrange,
        [theme.breakpoints.up(600)]:{
            transform: 'scale(2)',
        }
    },
    warningText: ({isWarning}) =>  ({
        fontWeight: isWarning ? 'bold' : '',
        fontSize: '1.3rem'
    }),
    warningModal: {
        padding: '2rem'
    },
    dialogTitle: {
        paddingLeft: '30%',
        color: colors.californiaBlue,
        fontWeight: 'bold',
        fontSize: '1.3rem'
    },
    title: {
        whiteSpace: 'pre-line'
    }

}));

export default useStyles;